module.exports = __webpack_public_path__ + "static/media/home-appliances.ab176755.svg";